(() => {
  const LOG = (...args) => console.log('[SSO_BUTTON]', ...args);
  const ERR = (...args) => console.error('[SSO_BUTTON_ERROR]', ...args);

  LOG('Script started');

  if (window.__ssoButtonHandlerInit) {
    LOG('Already initialized, exiting (guard active)');
    return;
  }
  window.__ssoButtonHandlerInit = true;

  const buildAuthUrl = (button) => {
    const authUrl = button.dataset.authUrl;
    const clientId = button.dataset.clientId;
    const idp = button.dataset.idp;
    const responseType = button.dataset.responseType;
    const scopes = button.dataset.scopes;
    const state = button.dataset.state;
    const redirectUri = button.dataset.redirectUri;

    LOG('buildAuthUrl button data:', {
      authUrl,
      clientId: clientId ? clientId.substring(0, 10) + '...' : undefined,
      idp,
      responseType,
      scopes,
      state,
      redirectUri,
    });

    if (!authUrl || !clientId || !idp || !responseType || !scopes || !redirectUri) {
      ERR('buildAuthUrl: required fields missing', {
        authUrl: !!authUrl,
        clientId: !!clientId,
        idp: !!idp,
        responseType: !!responseType,
        scopes: !!scopes,
        redirectUri: !!redirectUri,
      });
      return '';
    }

    const params = new URLSearchParams();
    params.set('client_id', clientId);
    params.set('idp', idp);
    params.set('redirect_uri', redirectUri);
    params.set('response_type', responseType);
    params.set('scope', scopes.replace(/,/g, ' '));
    if (state) params.set('state', state);

    const finalUrl = `${authUrl}?${params.toString()}`;
    LOG('buildAuthUrl generated URL:', finalUrl);
    return finalUrl;
  };

  const bindButtons = () => {
    const buttons = document.querySelectorAll('[data-sso-button="true"]');
    LOG('bindButtons: found', buttons.length, 'SSO button(s)');

    buttons.forEach((button, i) => {
      if (button.dataset.ssoBound === 'true') {
        LOG(`bindButtons: button #${i} already bound, skipping`);
        return;
      }
      button.dataset.ssoBound = 'true';
      LOG(`bindButtons: binding button #${i}`, button.textContent?.trim());

      button.addEventListener('click', () => {
        LOG(`SSO button #${i} clicked`);
        const url = buildAuthUrl(button);
        if (!url) {
          ERR('SSO URL is empty, aborting redirect');
          return;
        }
        LOG('Redirecting to Okta:', url);
        window.location.href = url;
      });
    });
  };

  if (document.readyState === 'loading') {
    LOG('DOM still loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    LOG('DOM already ready, calling bindButtons immediately');
    bindButtons();
  }

  const observer = new MutationObserver(bindButtons);
  observer.observe(document.body, { childList: true, subtree: true });
})();
